import React from 'react';
import {
  Item,
  ItemDefinition,
  ItemValidationError,
  registry,
  RenderProps
} from '../Item';
import { FLIP_BACK, FLIP_CARD } from '../itemIds';

export type FlipBackDefinition = ItemDefinition<typeof FLIP_BACK, void>;

export class FlipBack extends Item<typeof FLIP_BACK, void> {
  protected validate() {
    if (this.parent?.type !== FLIP_CARD) {
      throw new ItemValidationError(
        `An item of type [${FLIP_BACK}] must be the child of an item of type [${FLIP_CARD}]`
      );
    }
  }

  protected render({ children }: RenderProps<void>) {
    return <>{children}</>;
  }
}

registry[FLIP_BACK] = FlipBack;
